// atob() decodes base64 into a binary string (one JS char per raw byte), not
// a UTF-8 string — use this instead when the base64 payload is UTF-8 text
// (e.g. HTML), or multi-byte characters (quotes, accents, ₹) turn into
// mojibake like "Â"/"â".
export default function decodeBase64Utf8(base64: string): string {
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder("utf-8").decode(bytes);
}
